module.exports = __webpack_public_path__ + "static/media/DSC03599.3ed5c504.JPG";